import { render, staticRenderFns } from "./HomeGameElement.vue?vue&type=template&id=54932dc2&scoped=true"
import script from "./HomeGameElement.vue?vue&type=script&lang=js"
export * from "./HomeGameElement.vue?vue&type=script&lang=js"
import style0 from "./HomeGameElement.vue?vue&type=style&index=0&id=54932dc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54932dc2",
  null
  
)

export default component.exports